var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenue2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transactions-icon copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-1219.000000, -177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Order-Copy-4",
    transform: "translate(1206.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Growth--Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transactions-icon-copy",
    transform: "translate(13.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style",
    opacity: 0,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#F6931E",
    opacity: 0.159999996,
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-rupee-3025334-copy",
    transform: "translate(13.000000, 9.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8373431,24.9534519 L0.870292887,13.209205 L0.870292887,11.4987971 L6.13023013,11.4987971 C8.83028243,11.4987971 11.0240586,9.30502092 11.0240586,6.60779289 C11.0240586,3.91056485 8.82740586,1.7167887 6.13023013,1.7167887 L0.0120292887,1.7167887 L0.0120292887,0.000679916318 L6.13023013,0.000679916318 C7.89497908,0.000679916318 9.55679916,0.687133891 10.803818,1.93420502 C12.0537134,3.18127615 12.7401674,4.84016736 12.7401674,6.60779289 C12.7401674,8.37541841 12.0537134,10.0343619 10.803818,11.2813808 C9.55674686,12.5284519 7.89785565,13.2149059 6.13023013,13.2149059 L3.03258368,13.2149059 L11.2015167,23.9120816 L9.8373431,24.9534519 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.0120292887 5.95031381 16.2008368 5.95031381 16.2008368 7.66642259 0.0120292887 7.66642259"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.0120292887 0.000836820084 16.2008368 0.000836820084 16.2008368 1.71694561 0.0120292887 1.71694561"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue2);
export default __webpack_public_path__ + "static/media/Revenue - 2.1aaf482f8f6d3840165100e8e74790f6.svg";
export { ForwardRef as ReactComponent };